<template>
  <div class="edit-live-review-tracker-map">
    <h3 class="title is-6 mb-2">Traces</h3>

    <map-view class="edit-live-review-tracker-map__map" :mapBounds="bounds">
      <edit-live-review-tracker-trace-layer
        v-for="trace in traces"
        :key="trace.trackerId"
        :trace="trace"
      />
    </map-view>

    <edit-live-review-tracker-coverage-legend class="mt-2" />
  </div>
</template>

<script>
import EditLiveReviewTrackerCoverageLegend from './EditLiveReviewTrackerCoverageLegend.vue'
import EditLiveReviewTrackerTraceLayer from './EditLiveReviewTrackerTraceLayer.vue'
import MapView from '@views/MapView/index.vue'

export default {
  name: 'EditLiveReviewTrackerMap',

  components: {
    EditLiveReviewTrackerCoverageLegend,
    EditLiveReviewTrackerTraceLayer,
    MapView,
  },

  props: {
    traces: {
      type: Array,
      required: true,
    },
  },

  computed: {
    bounds() {
      let minLatitude = Infinity
      let minLongitude = Infinity
      let maxLatitude = -Infinity
      let maxLongitude = -Infinity

      for (const { points } of this.traces) {
        for (const point of points) {
          minLatitude = Math.min(minLatitude, point[1])
          minLongitude = Math.min(minLongitude, point[0])
          maxLatitude = Math.max(maxLatitude, point[1])
          maxLongitude = Math.max(maxLongitude, point[0])
        }
      }

      if (minLatitude === Infinity) {
        return null
      }

      return [
        [minLatitude, minLongitude],
        [maxLatitude, maxLongitude],
      ]
    },
  },
}
</script>

<style lang="scss">
@import 'variables';

.edit-live-review-tracker-map {
  display: flex;
  flex-direction: column;

  &__map {
    height: 500px;
  }

  @include desktop {
    height: 100%;

    &__map {
      flex: 1;
      height: auto;
    }
  }
}
</style>
